import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as R from 'ramda'

import HorizontalTableInput from 'components/form/horizontalTableInput'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import horizontalTableInputReducer from './reducer'
import injectReducer from 'helpers/injectReducer'
import getSelectors from './selectors'
import { getElementKeySelector, getRowFormatSelector } from './selectors'
import {
  horizontalTableAdd,
  horizontalTableRemove,
  horizontalTableUpdate,
  horizontalTableNestedAdd,
  horizontalTableNestedRemove,
  horizontalTableNestedUpdate
} from './actions'
import {
  getPath,
  combinePath
} from 'containers/Form/util'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const reducer = createNamedReducer(valuePath, horizontalTableInputReducer)
  return injectReducer(valuePath, reducer)
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const {
    valuesSelector,
    labelSelector,
    hintSelector
  } = getSelectors(combinedPath)

  const horizontalTableAddAction = createNamedAction(valuePath, horizontalTableAdd)
  const horizontalTableRemoveAction = createNamedAction(valuePath, horizontalTableRemove)
  const horizontalTableUpdateAction = createNamedAction(valuePath, horizontalTableUpdate)

  const horizontalTableNestedAddAction = createNamedAction(valuePath, horizontalTableNestedAdd)
  const horizontalTableNestedRemoveAction = createNamedAction(valuePath, horizontalTableNestedRemove)
  const horizontalTableNestedUpdateAction = createNamedAction(valuePath, horizontalTableNestedUpdate)

  const mapStateToProps = (state) => {
    return {
      title: labelSelector(state),
      values: valuesSelector(state),
      hint: hintSelector(state),
      rowFormat: getRowFormatSelector(id)(state),
      elementKey: getElementKeySelector(id)(state)
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      horizontalTableAdd: () => dispatch(horizontalTableAddAction()),
      horizontalTableRemove: (index) => dispatch(horizontalTableRemoveAction(index)),
      horizontalTableUpdate: (index, element, value) => dispatch(horizontalTableUpdateAction(index, element, value)),
      horizontalTableNestedAdd: (colKey, horizontalTableIndex) => dispatch(horizontalTableNestedAddAction(colKey, horizontalTableIndex)),
      horizontalTableNestedRemove: (horizontalTableIndex, colKey, verticalTableIndex) => dispatch(horizontalTableNestedRemoveAction(horizontalTableIndex, colKey, verticalTableIndex)),
      horizontalTableNestedUpdate: (horizontalTableIndex, colKey, verticalTableIndex, nestedColKey, value) => dispatch(horizontalTableNestedUpdateAction(horizontalTableIndex, colKey, verticalTableIndex, nestedColKey, value))
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

export { default as HorizontalTableInput } from 'components/form/horizontalTableInput'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id)
)(HorizontalTableInput))
